import { render } from "./latest-blog.vue?vue&type=template&id=b982cf54"
import script from "./latest-blog.vue?vue&type=script&lang=js"
export * from "./latest-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__